import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAppToast } from './use-app-toast';

export function QueryErrorToaster() {
  const queryClient = useQueryClient();
  const { showError } = useAppToast();

  useEffect(() => {
    const mutationCache = queryClient.getMutationCache();
    return mutationCache.subscribe((event) => {
      if (event.type === 'updated' && event.mutation.state.status === 'error') {
        showError(event.mutation.state.error);
      }
    });
  }, [queryClient, showError]);

  return null;
}
